import React, { Component } from 'react';
import { connect } from 'react-redux';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Checkbox } from '@material-ui/core';

import CustomizedDialog from '../Dialog/CustomizedDialog';
import { boardService, opbcdtService } from '../../services';
import { alertActions } from '../../modules/alert';
import moment from 'moment';
import ContentsThumbnail from '../ContentsMng/ContentsThumbnail';

class ContentsAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            siteID: props.siteID,
            opbID: props.opbID,
            opbNo: props.opbNo,
            contentTypeCode: props.contentTypeCode,
            addContentType: "addOpbContent",
            opbList: [],
            contentsList: {
                currentPage: 1,
                listCount: 1000,
                start: 1,
                boardList: []
            },
            selectOpbID: 0,
            checkedBoards: [],
            checkedAllBoards: false,
            isMobile: props.isMobile,
        };

        this.setOpbList();
        this.setContentsList();
    }

    setOpbList = async () => {
        // Display 목록 조회 
        const { siteID, opbID, opbNo, contentTypeCode } = this.state;
        let formData = new FormData();
        formData.append('siteID', siteID);
        formData.append('opbID', opbID);
        formData.append('opbNo', opbNo);
        formData.append('typeCodes', [contentTypeCode]);

        opbcdtService.findOpbContent(formData)
            .then(response => {
                this.setState({
                    opbList: response.data.opbList
                });
            })
            .catch(this.handleErrors);
    };

    setContentsList = async () => {
        // 홍보영상/마케팅영상/하단영상 목록 조회
        let formData = new FormData();
        const { siteID, contentsList, contentTypeCode } = this.state;

        formData.append('siteID', siteID);
        formData.append('currentPage', contentsList.currentPage);
        formData.append('contentTypeCode', contentTypeCode);
        formData.append('listCount', contentsList.listCount);

        boardService.findByBoard(formData)
            .then(response => {
                this.setState({
                    checkedBoards: [],
                    checkedAllBoards: false,
                    contentsList: response.data
                });
            })
            .catch(this.handleErrors);
    };


    handleFormSubmit = (e) => {
        e.preventDefault();

        // addContentType = addOpbContent: 공지추가팝업 > 선택한엘리베이터와 동일하게 설정
        // Display 설정 목록 추가
        // addContentType = addSelectContent: 공지추가팝업 > 공지설정
        // 컨텐츠 선택 추가
        let addList = [];
        if (this.state.addContentType === "addOpbContent") {
            let formData = new FormData();
            formData.append("opbID", this.state.selectOpbID);

            opbcdtService.selectedOpb(formData)
                .then(response => {
                    addList = (this.props.contentTypeCode === "CT002" ? response.data.promotionList : this.props.contentTypeCode === "CT003" ? response.data.marketingList : response.data.bottomList);
                    addList = addList.map(board => {
                        board.opbID = this.state.opbID;
                        board.opbcontentID = -1;
                        return board;
                    });

                    this.props.setContentListAdd(this.props.contentTypeCode, addList, this.state.addContentType);
                })
                .catch(this.handleErrors);
        }
        else {
            addList = this.state.checkedBoards.map(board => {
                board.typeCode = this.props.contentTypeCode;
                return this.setAddList(board);
            });

            this.props.setContentListAdd(this.props.contentTypeCode, addList, this.state.addContentType);
        }

        this.handleClose();
    };

    setAddList = (board) => {
        const content = {
            boardID: board.boardID,
            boardfileID: board.attachedFiles.length !== 0 ? board.attachedFiles[(board.attachedFiles.length - 1)].boardFileID : 0,
            thumbnailfileID: board.contentKindCode === "CK002" && board.attachedFiles.length !== 0
                ? board.attachedFiles[(board.attachedFiles.length - 1)].boardFileID
                : ((board.thumbnailFiles.length !== 0) ? board.thumbnailFiles[(board.thumbnailFiles.length - 1)].boardFileID : 0),
            boardinfoID: board.boardInfoID,
            content: board.content,
            contentKindCode: board.contentKindCode,
            contentVolume: 0.5,
            dowMask: "0000000",
            enabledDate: 0,
            enabledDow: 0,
            enabledTime: 0,
            endDate: this.props.coEndDate,
            endTime: "23:59:59",
            opbID: this.state.opbID,
            opbcontentID: -1,
            showTime: 180000,
            siteID: -1,
            sort: -1,
            startDate: moment(this.props.coBeginDate).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD') ? this.props.coBeginDate : moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
            startTime: "00:00:00",
            title: board.title,
            typeCode: board.typeCode,
            useYN: "Y",
        };

        return content;
    };

    handleValueChange = (e) => {
        if (e.target.name === "addContentType") {
            this.setState({
                [e.target.name]: e.target.value,
                selectOpbID: "0",
                checkedBoards: [],
                checkedAllBoards: false
            });
        }
        else {
            this.setState({
                [e.target.name]: e.target.value,
            });
        }
    };

    handleAllBoardCheck = (e) => {
        // 공지추가팝업 > 공지추가 > 전체선택
        this.setState({
            checkedAllBoards: e.target.checked,
            checkedBoards: e.target.checked ? this.state.contentsList.boardList : []
        });
    };

    handleBoardCheck = (board, checked) => {
        // 공지추가팝업 > 공지추가 > 공지선택 > 개별선택
        const { checkedBoards, contentsList } = this.state;
        const { totalCount } = contentsList;

        this.setState({
            checkedBoards: checked ? checkedBoards.concat(board) : checkedBoards.filter(checkedBoard => checkedBoard !== board),
            checkedAllBoards: checked ? checkedBoards.concat(board).length === totalCount : false
        });
    };


    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleClickOpen = () => {
        this.setState({
            addContentType: "addOpbContent",
            siteID: this.props.siteID,
            opbID: this.props.opbID,
            opbNo: this.props.opbNo,
            contentTypeCode: this.props.contentTypeCode,
            isMobile: this.props.isMobile,
            selectOpbID: "0",
            open: true
        }, () => {
            this.setOpbList();
            this.setContentsList();
        });
    };

    handleClose = () => {
        this.setState({
            selectOpbID: "0",
            checkedBoards: [],
            checkedAllBoards: false,
            open: false,
        });
    };

    render() {
        const { isMobile, open, contentTypeCode, addContentType, opbList, contentsList, selectOpbID, checkedAllBoards, checkedBoards } = this.state;
        let contentType = "";
        if (contentTypeCode === "CT002") contentType = "상단영상";
        else if (contentTypeCode === "CT003") contentType = "중앙영상";
        else if (contentTypeCode === "CT004") contentType = "하단영상";

        return (
            <>
                <button className={`button ${isMobile ? "contentsAdd-button" : "w120-button"}`} onClick={this.handleClickOpen}>영상추가</button>
                <CustomizedDialog title={contentType + " 추가"} isFullScreen={isMobile} open={open} handleClose={this.handleClose}>
                    <div className="dialog-content opbState-mng-add">
                        <div>
                            <RadioGroup name="addContentType" value={addContentType} onChange={this.handleValueChange}>
                                <FormControlLabel name="addContentType" value="addOpbContent" control={<Radio color="primary" />} label="선택한 엘리베이터와 동일하게 설정" />
                            </RadioGroup>
                        </div>
                        <div>
                            <select className="w100per input-box" name="selectOpbID" value={selectOpbID} disabled={addContentType !== "addOpbContent" && true} onChange={this.handleValueChange}>
                                <option value="0">선택하세요.</option>
                                {opbList && opbList.map((opbInfo, i) => {
                                    return <option key={i} value={opbInfo.opbID}>{`${opbInfo.opbName} (${opbInfo.imei})`}</option>;
                                })}
                            </select>
                        </div>
                        <div>
                            <RadioGroup name="addContentType" value={addContentType} onChange={this.handleValueChange}>
                                <FormControlLabel name="addContentType" value="addSelectContent" control={<Radio color="primary" />} label={contentType + " 선택"} />
                            </RadioGroup>
                        </div>
                        <div className={`opbState-mng-add-table ${addContentType === "addOpbContent" ? " disabled" : ""}`}>
                            <table className="w100per">
                                <colgroup>
                                    <col width="10%" />
                                    <col width="20%" />
                                    <col width="15%" />
                                    <col width="55%" />
                                </colgroup>
                                <thead className="table-head">
                                    <tr>
                                        <th><Checkbox color="primary" onChange={this.handleAllBoardCheck} checked={checkedAllBoards} disabled={addContentType === "addOpbContent" && true} /></th>
                                        <th>NO</th>
                                        <th colSpan="2">내용</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    {contentsList.boardList && contentsList.boardList.map((board, i) => {
                                        return <ContentsAddItem key={i} no={contentsList.start + i} addContentType={addContentType} board={board} ck={checkedBoards.indexOf(board) > -1} handleBoardCheck={this.handleBoardCheck} />;
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className="dialog-button-group">
                            <button className={`button w100-button ${(selectOpbID !== "0" || checkedBoards.length !== 0) ? "" : " disabled-button"}`} onClick={this.handleFormSubmit} ref={button => this.buttonAdd = button} disabled={(selectOpbID !== "0" || checkedBoards.length !== 0) ? false : true}>추가</button>
                            <button className="button outline-button" onClick={this.handleClose}>취소</button>
                        </div>
                    </div>
                </CustomizedDialog>
            </>
        );
    }
}


const ContentsAddItem = React.memo(
    function ContentsAddItem({ no, addContentType, board, ck, handleBoardCheck }) {
        const { title, contentKindCode, boardID, attachedFiles, thumbnailFiles } = board;

        let boardFileID = 0;
        if (contentKindCode === "CK002" && attachedFiles.length > 0) boardFileID = attachedFiles[(attachedFiles.length - 1)].boardFileID;
        if (contentKindCode === "CK003" && thumbnailFiles.length > 0) boardFileID = thumbnailFiles[(thumbnailFiles.length - 1)].boardFileID;

        return (
            <>
                <tr>
                    <td className="text-align-center"><Checkbox color="primary" onChange={() => { handleBoardCheck(board, !ck); }} checked={ck} disabled={addContentType === "addOpbContent" && true} /></td>
                    <td className="text-align-center">{no}</td>
                    <td className="text-align-center"><ContentsThumbnail contentKindCode={contentKindCode} boardID={boardID} boardFileID={boardFileID} /></td>
                    <td className="text-align-left">{title}</td>
                </tr>
            </>
        );
    }
);


function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(ContentsAdd);